import { ReactNode } from 'react';

import { useRouteRef } from '@backstage/core-plugin-api';
import { Link } from '@backstage/ui';

import {
  extractLastNameComponent,
  extractWorkflowFromInstanceName,
} from '@spotify/confidence-core-react';

import { useWorkflowInstanceRef } from '../../hooks/useWorkflowInstanceRef';
import { workflowInstanceRouteRef } from '../../routes';

export interface WorkflowInstanceResourceLinkProps {
  name: string;
  text: ReactNode;
}

export const WorkflowInstanceResourceLink = (
  props: WorkflowInstanceResourceLinkProps,
) => {
  const { name, text } = props;

  const routeRef = useRouteRef(workflowInstanceRouteRef);

  const href = routeRef({
    workflow: extractWorkflowFromInstanceName(name)!,
    id: extractLastNameComponent(name)!,
  });

  const { workflowInstance } = useWorkflowInstanceRef({ name });

  return (
    <Link href={href} weight="bold">
      {workflowInstance?.displayName || text}
    </Link>
  );
};
